import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

export default new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            name: 'home',
            component: () => import('../pages/Home/Home'),
        },
        {
            path: '/terms',
            name: 'terms',
            component: () => import('../pages/Home/Terms'),
        },
        {
            path: '/contacts',
            name: 'contacts',
            component: () => import('../pages/Contacts/Contacts'),
        },
        {
            path: '/faq',
            name: 'faq',
            component: () => import('../pages/QnA/QnA'),
        },
        {
            path: '/register/:code',
            name: 'register.partner',
            component: () => import('../pages/Home/Home'),
        },
        ...require('./master').default,
        ...require('./coworking').default,
        require('./cabinet/master').default,
        require('./cabinet/client').default,
        require('./cabinet/admin').default,
        ...require('./error').default,
    ]
});
